<template>
  <div class="headingProduceInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      打頭生產資訊
    </li>
    <b-table
      :items="headingProduceInformationItem"
      :fields="headingProduceInformationFields"
      class="text-center headingProduceInformation-table-detail"
    >
      <template #head(item_title)="">
        <div class="headingProduceInformation-table-line">
          <span class="headingProduceInformation-table-item">項目</span>
          <span class="headingProduceInformation-table-status">狀態</span>
        </div>
      </template>
      <template #cell(qty)="row" style="">
        {{ row.item["qty"].name }}:
        {{ row.item["qty"].count.toLocaleString("en-US") }}
      </template>
      <template #cell(standard_total_weight)="data" style="">
        {{ data.value.toLocaleString("en-US") }}
      </template>
      <template #cell(material_total_weight)="data" style="">
        {{ data.value.toLocaleString("en-US") }}
      </template>
      <!-- {{ (398000).toLocaleString("en-US") }} -->
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "headingProduceInformation",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      headingProduceInformationFields:
        "headingProduceInformation/get_headingProduceInformationFields",
      headingProduceInformationItem: "headingProduceInformation/get_headingProduceInformationItem",
    }),
  },
};
</script>

<style lang="scss">
.headingProduceInformation-table-line {
  border-top: 2.8rem #cccccc solid; /*上邊框寬度等於表格第一行行高*/
  width: 0px; /*讓容器寬度為0*/
  height: 0px; /*讓容器高度為0*/
  border-left: 5rem #bdbdbd solid; /*左邊框寬度等於表格第一行第一格寬度*/
  position: relative; /*讓裡面的兩個子容器絕對定位*/
  color: #000000;
}
.headingProduceInformation-table-item {
  font-style: normal;
  display: block;
  position: absolute;
  top: -43px;
  left: -40px;
  width: 2.8rem;
  font-family: "dfyuanstd-w5";
}
.headingProduceInformation-table-status {
  font-style: normal;
  display: block;
  position: absolute;
  top: -20px;
  left: -85px;
  width: 2.8rem;
  font-family: "dfyuanstd-w5";
}

.headingProduceInformation-table-detail thead th {
  border-top: 1px solid;
}
.headingProduceInformation-table-detail th,
.headingProduceInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  vertical-align: middle !important;
}
.headingProduceInformation-table-detail th:first-child,
.headingProduceInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.headingProduceInformation-table-detail {
  margin-bottom: 0px;
}
.headingProduceInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.headingProduceInformation-table-detail thead tr:last-child th:nth-child(1) {
  width: 5rem;
  min-width: 5rem;
}
.headingProduceInformation-table-detail thead tr:last-child th:nth-child(2) {
  min-width: 5rem;
}
.headingProduceInformation-table-detail thead tr:last-child th:nth-child(3) {
  min-width: 8rem;
}
.headingProduceInformation-table-detail thead tr:last-child th:nth-child(4) {
  min-width: 10rem;
}
.headingProduceInformation-table-detail thead tr:last-child th:nth-child(5) {
  min-width: 10rem;
}
.headingProduceInformation-table-detail thead tr:last-child th:nth-child(6) {
  min-width: 5rem;
}
.headingProduceInformation-table-detail thead tr:last-child th:nth-child(7) {
  min-width: 5rem;
}
.headingProduceInformation-table-detail tr td {
  background-color: #ffffff;
}
.headingProduceInformation-table-detail tr td:nth-child(1) {
  background-color: #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/components/headingProduceInformation.vue